import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import MainContentPending from '../pageStructure/mainContentPending/';
import AccountCard from './accountCard/AccountCard';
import PartyCalculatorSVG from '../../svgComponents/partyCalculatorSVG/PartyCalculatorSVG';
import styles from './AccountHistory.module.css';
import messages from './AccountHistory.messages';
import { useQuery } from '@tanstack/react-query';
import { RootState } from '@iwProvider/configureStore';
import { useEffect } from 'react';
import { trackPageView } from '../../tracking/pageView';
import { getAccountsQueryConfig } from '@api/lendingAPI/queryConfigs';

const mapStateToProps = (state: RootState) => ({
    ready: state.accountHistory.ready,
    stateKey:
        state.siteContext.impersonatingStateKey || state.siteContext.state_key
});

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const AccountHistory = ({ ready, stateKey }: PropsFromRedux) => {
    const {
        isLoading,
        isError,
        data: getAccountsResponse
    } = useQuery(getAccountsQueryConfig(stateKey!));

    useEffect(() => {
        if (!isLoading && stateKey) {
            trackPageView(stateKey, 'Account History');
        }
    }, [stateKey, isLoading]);

    if (!ready || isLoading || isError) {
        return <MainContentPending data-testid="account-history-loading" />;
    }

    const accountsWithLoans = getAccountsResponse.data!.accounts.filter(
        (account) => account.account_id
    );

    if (!accountsWithLoans.length) {
        return (
            <div className={styles.AccountHistoryNone}>
                <h1 className={styles.title}>
                    <FormattedMessage {...messages.noAccounts} />
                </h1>

                <p className={styles.subTitle}>
                    <FormattedMessage {...messages.subTitle} />
                </p>

                <hr className={styles.divider} />

                <PartyCalculatorSVG />
            </div>
        );
    }

    return (
        <div className={styles.AccountHistory}>
            <h1 className={styles.title}>
                <FormattedMessage {...messages.title} />
            </h1>

            <p className={styles.subTitle}>
                <FormattedMessage {...messages.subTitle} />
            </p>

            <hr className={styles.divider} />

            <div className={styles.accountCards}>
                {accountsWithLoans.map((account) => (
                    <AccountCard
                        key={account.account_id}
                        accountId={account.account_id!}
                        productType={account.product_type!}
                        balance={account.balance!.total!}
                        duration={account.duration!}
                    />
                ))}
            </div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(AccountHistory);

export const parseTransactionNumber = (number: number) =>
    number ? Math.abs(number) : 0;
